import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs/internal/Observable';
import { ENVIRONMENT } from '../../../environments/environment';
import { RouterState } from '../../features/auth/redux/router-state';
@Injectable({ providedIn: 'root' })

// This class is used to restrict access to a certain feature on the UI based on the user's OKTA groups
export class OktaRestriction {
  public userGroup$: Observable<any> = inject(Store).select(RouterState.user_groups);

  public user_groups = [];

  // This permission allows users to see create/edit/delete options on the UI
  public manager_permission = false;

  // This permission allows users to see the campaign promotion button
  public promotion_permission = false;

  // This permission allows users to see and access the QA Tools section of the UI
  public qa_permission = false;

  // This permission allows users to see and access the DRB section of the UI. Cannot deploy on prod
  public drb_user_permission = false;

  // This permission allows users to see and access the DRB section of the UI + deploy on prod
  public drb_manager_permission = false;

  constructor() {
    this.userGroup$.subscribe((data) => (this.user_groups = data));
    this.manager_permission = this.user_groups.includes(ENVIRONMENT.oktaGroups.campaign_manager);
    this.promotion_permission = this.user_groups.includes(ENVIRONMENT.oktaGroups.promoter);
    this.qa_permission = this.user_groups.includes(ENVIRONMENT.oktaGroups.qa);
    this.drb_user_permission = this.user_groups.includes(ENVIRONMENT.oktaGroups.drb_user);
    this.drb_manager_permission = this.user_groups.includes(ENVIRONMENT.oktaGroups.drb_manager);
  }
}
